
import { Component, Vue } from "vue-property-decorator";
import RecoverPassComponent from "@/components/auth/RecoverPassComponent.vue";

@Component({
  components: {
    RecoverPassComponent
  },
  meta: {
    // sets document title
    title: "Recuperar - Tarjeta Pircana",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Recuperar Cuenta Tarjeta Pircana."
      },
      keywords: { name: "keywords", content: "Tarjeta Pircana" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class RecoverPassView extends Vue {}
